import React from 'react';
import { Layout } from 'antd';
import { connect } from 'react-redux';

const { Footer } = Layout;

const FooterComponent = ({ hideElimiWaitLogo }) => {
  return hideElimiWaitLogo ? null : (
    <Footer style={{ textAlign: 'center', backgroundColor: 'black' }}>
      <img
        src='https://rcs-company-logos.s3.amazonaws.com/elimiwait_simple_logo_v1.png'
        width='auto'
        height='80'
        alt='ElimiWait Logo'
        id='elimiWaitLogo'
      />
      <br />
      <br />
      <div>
        <a
          style={{
            color: 'white',
            textDecoration: 'underline',
          }}
          href='https://elimiwaitparking.com/'
          target='_blank'
          rel='noopener noreferrer'
        >
          Powered by ElimiWait&nbsp;
        </a>
      </div>
    </Footer>
  );
};

const mapStateToProps = (state) => {
  return {
    hideElimiWaitLogo: state.logoResponse.hideElimiWaitLogo,
  };
};

export default connect(mapStateToProps)(FooterComponent);
